import { useState } from "react";
import { PageHeader } from "../../../components";
import { Card } from "../../../components/card.component";
import {
  ActivateSync,
  AppointmentDataExchange,
  CaregiverDataExchangeTable,
  PatientDataExchangeTable, // Add the import for PatientDataExchangeTable
} from "../../../features/data-exchange";
import { StorageAuth } from "../../../core/localStorage";

export function PageDataExchange() {
  const [hasToken, setHasToken] = useState(false);
  const [activeTab, setActiveTab] = useState("appointment");
  const selectedCompany = StorageAuth.CompanyId;

  return (
    <Card header={<PageHeader title="Data Exchange" />}>
      <div className="d-flex justify-content-between my-2">
        <ActivateSync setHasToken={setHasToken} key={selectedCompany} />
      </div>

      {hasToken && selectedCompany && (
        <>
          <div>
            <ul className="nav nav-tabs mb-3" role="tablist">
              <li className="nav-item" role="presentation">
                <button 
                  className={`nav-link ${activeTab === "appointment" ? "active" : ""}`} 
                  id="appointment-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#appointment"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("appointment")}
                >
                  Appointment
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "caregiver" ? "active" : ""}`}
                  id="caregiver-tab"
                  data-bs-toggle="tab" 
                  data-bs-target="#caregiver"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("caregiver")}>
                  Caregiver
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "patient" ? "active" : ""}`}
                  id="patient-tab" 
                  data-bs-toggle="tab"
                  data-bs-target="#patient"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("patient")}
                >
                  Patient
                </button>
              </li>
            </ul>

            <div className="tab-content">
              <div 
                className={`tab-pane fade ${activeTab === "appointment" ? "show active" : ""}`} 
                id="appointment" 
                role="tabpanel"
              >
                <AppointmentDataExchange 
                  selectedCompany={selectedCompany} 
                  key={selectedCompany}
                />
              </div>
              <div 
                className={`tab-pane fade ${activeTab === "patient" ? "show active" : ""}`} 
                id="patient" 
                role="tabpanel"
              >
                <PatientDataExchangeTable
                  selectedCompany={selectedCompany}
                  key={selectedCompany}
                />
              </div>
              <div 
                className={`tab-pane fade ${activeTab === "caregiver" ? "show active" : ""}`} 
                id="caregiver" 
                role="tabpanel"
              >
                <CaregiverDataExchangeTable
                  selectedCompany={selectedCompany}
                  key={selectedCompany}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </Card>
  );
}
